import Spacing from "@/components/common/Spacing";
import "./inclusives.scss";
import { Container } from "react-bootstrap";
import decor from "@/assets/line-group-2.png";
interface Data {
  inclusiveTitle: string;
  inclusives: string[];
}

interface Props {
  data: Data;
  hideDecor?: boolean;
}

const Inclusives = ({ data, hideDecor }: Props) => {
  return (
    <div className="inclusives-container">
      {!hideDecor && (
        <img src={decor} alt="pixado" className="inclusives-decor" />
      )}
      <Container>
        <Spacing size={3} />
        <div className="inclusives">
          <div className="title-2 inclusiveTitle">{data.inclusiveTitle}</div>
          <div className="bubble inclusives-bubble">
            <div className="body">
              {data.inclusives.map((item, index) => (
                <div key={index}>
                  {item}
                  {index < data.inclusives.length - 1 && <br />}
                </div>
              ))}
            </div>
          </div>
        </div>
        <Spacing size={3} />
      </Container>
    </div>
  );
};

export default Inclusives;
